import { format, differenceInDays } from "date-fns";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import { pad } from "utils/getLocalDateTime";

const legacyStatus21 = [
  "600072307",
  "600271044",
  "600538037",
  "600148552",
  "600302227",
  "600197608",
  "600245083",
  "600087232",
  "600092096",
  "600166613",
  "600274674",
  "600094908",
  "600072689",
  "600306603",
  "600236023",
  "600456063",
  "600413046",
  "600481127",
  "600138331",
  "600240081",
  "600196177",
  "600286888",
  "600238015",
  "600156083",
  "600169574",
  "600365984",
  "600476899",
  "600019635",
  "600519545",
  "600079584",
  "600055594",
  "600132582",
  "600110130",
  "600182116",
  "600236024",
  "600270665",
  "600351879",
  "600127698",
  "600492191",
  "600460266",
  "600110156",
  "600418208",
  "600255761",
  "600440859",
  "600169192",
  "600471651",
  "600390071",
  "600399972",
  "600089263",
  "600443330",
  "600340462",
  "600076547",
  "600251057",
  "600103015",
  "600459657",
  "600297088",
  "600016344",
  "600143107",
  "600175069",
  "600237896",
  "600167814",
  "600041712",
  "600381567",
  "600431100",
  "600552553",
  "600367481",
  "600454813",
  "600128235",
  "600105044",
  "600271949",
  "600019369",
  "600076899",
  "600033710",
  "600509158",
  "600540789",
  "600424457",
  "600186663",
  "600255254",
  "600273808",
  "600473750",
  "600091820",
  "600023312",
  "600250521",
  "600281934",
  "600210617",
  "600104681",
  "600025752",
  "600420631",
  "600069970",
  "600497217",
  "600207875",
  "600212980",
  "600558717",
  "600123747",
  "600429020",
  "600537809",
  "600025681",
  "600246630",
  "480022637",
  "600327960",
  "600191589",
  "600081527",
  "600513117",
  "600189908",
  "600317110",
  "600387764",
  "600117643",
  "600235014",
  "600433898",
  "600108841",
  "600352067",
  "600341537",
  "600092140",
  "600504923",
  "600405023",
  "600240715",
  "600359315",
  "600016212",
  "600522305",
  "600346078",
  "600471172",
  "600213343",
  "600210576",
  "600475094",
  "600210205",
  "600013986",
  "600420392",
  "600513661",
  "600537676",
  "600463726",
  "600128355",
  "600167317",
  "600095516",
  "600171802",
  "600342054",
  "600198022",
  "600257484",
  "600222095",
  "600380087",
  "600147700",
  "600463755",
  "600251255",
  "600213086",
  "600362340",
  "600368584",
  "600356400",
  "600441943",
  "600202807",
  "600105413",
  "600101656",
  "600546458",
  "600459505",
  "600493268",
  "600303875",
  "600312311",
  "600216666",
  "600145149",
  "600181565",
  "600104121",
  "600359195",
  "600534405",
  "600462613",
  "600545237",
  "600251052",
  "600144992",
  "600095777",
  "600411959",
  "600299693",
  "600498191",
  "600562224",
  "600049816",
  "600240496",
  "600432861",
  "600544454",
  "600548911",
  "600419460",
  "600092215",
  "600576312",
  "600224079",
  "600200875",
  "600305125",
  "600108988",
  "600116878",
  "600319253",
  "600463859",
  "600258264",
  "600082907",
  "600331666",
  "600115231",
  "600067905",
  "600105851"
];

export const default_date = "19000101";

const round = (number, digits) => {
  var factor = Math.pow(10, digits);
  return Math.round(number * factor) / factor;
};

export const getHeaderTUDF = ({
  env = "production",
  dataExport = [],
  currentDate = "",
}) => {
  const headerTUDF = {
    headerSegment: {
      position: 1,
      fixedLength: 4,
      value: "TUDF",
      defaultValue: " ",
      isPrefix: true,
      length: 4,
    },
    version: {
      position: 5,
      fixedLength: 2,
      value: "13",
      defaultValue: " ",
      isPrefix: true,
      length: 2,
    },
    memberCode: {
      position: 7,
      fixedLength: 10,
      value: "CC21070000",
      defaultValue: " ",
      isPrefix: true,
      length: "CC21070000".length,
    },
    memberName: {
      position: 17,
      fixedLength: 16,
      value: "MHS",
      defaultValue: " ",
      isPrefix: true,
      length: 3,
    },
    cycleIdentification: {
      position: 33,
      fixedLength: 2,
      value: "",
      defaultValue: " ",
      isPrefix: true,
      length: 2,
    },
    asOfDate: {
      position: 35,
      fixedLength: 8,
      value: `${format(new Date(currentDate), "yyyyMMdd")}`,
      defaultValue: " ",
      isPrefix: true,
      length: `${format(new Date(currentDate), "yyyyMMdd")}`.length,
    },
    password: {
      position: 43,
      fixedLength: 8,
      value: env === "test" ? "2A68Q883" : "5FB44922", //5FB44922 production  //2A68Q883 test
      defaultValue: " ",
      isPrefix: true,
      length: env === "test" ? "2A68Q883".length : "5FB44922".length,
    },
    futureUse: {
      position: 51,
      fixedLength: 2,
      value: "00",
      defaultValue: " ",
      isPrefix: true,
      length: 2,
    },
    memberData: {
      position: 53,
      fixedLength: 40,
      value: "",
      defaultValue: " ",
      isPrefix: true,
    },
    tracingNumber: {
      position: 93,
      fixedLength: 8,
      value: `${dataExport.length}`,
      defaultValue: "0",
      isPrefix: false,
      length: dataExport.length,
    },
  };

  let headerStr = "";
  Object.keys(headerTUDF).map((key) => {
    if (headerTUDF[key]) {
      const item = headerTUDF[key];
      var keepStr = "";
      if (!item.value || item.value.length !== item.fixedLength) {
        const fixedLength = item.fixedLength - item.value.length;
        for (let i = 0; i < fixedLength; i++) {
          keepStr += item.defaultValue;
        }
      } else if (item.value.length > item.fixedLength) {
        keepStr += item.value.slice(0, item.fixedLength);
      }
      if (item.isPrefix) {
        headerStr += item.value + keepStr;
      } else {
        headerStr += keepStr + item.value;
      }
    }
  });
  return headerStr;
};

export const getNamePnSegment = ({ data }) => {
  const splitName = String(data.name).split(" ");
  let name = data.name;
  if (splitName.length > 0) {
    name = splitName[0];
  }

  const namePnSegment = {
    pnSegmentTag: { fixedLength: 3, value: "N01", tag: "PN", length: "3" },
    familyName: {
      fixedLength: 50,
      value: String(data.lastname)?.replaceAll("​​", ""),
      tag: "01",
      length: String(data.lastname)?.replaceAll("​​", "").length,
    },
    firstName: {
      fixedLength: 30,
      value: String(name)?.replaceAll("​​​", ""),
      tag: "04",
      length: String(name)?.replaceAll("​​", "").length,
    },
    dateOfBirth: {
      fixedLength: 8,
      value: getValueDateOfBirth({ data }),
      tag: "07",
      length: `${getValueDateOfBirth({ data })}`.length,
    },
    customerType: {
      fixedLength: 1,
      value: "1",
      tag: "15",
      length: 1,
    },
  };

  // console.log("namePnSegment", namePnSegment);

  return namePnSegment;
};

export const getIdSegment = ({ data }) => {
  const idSegment = {
    idSegmentTag: { fixedLength: 3, value: "ID1", tag: "ID", length: 3 },
    idType: { fixedLength: 2, value: "01", tag: "01", length: 2 },
    idNumber: {
      fixedLength: 20,
      value: data?.citizenid || "",
      tag: "02",
      length: data?.citizenid?.length,
    },
  };
  return idSegment;
};

export const getAddressSegment = ({ data, addressComma = false }) => {
  let currentAddress = data.addressCode + data.addressDesc + data.address;

  if (addressComma) {
    currentAddress =
      data.addressCode + " " + data.addressDesc + " " + data.address;
  }

  if (!data.addressCode && !data.addressDesc && !data.address) {
    currentAddress = data.currentAddress;
  }

  if (!addressComma) {
    currentAddress = currentAddress
      // .replaceAll("/", " ")
      // .replaceAll(",", "")
      // .replaceAll(" ", "")
      ?.replaceAll("?", " ");
  }

  const addressSegment = {
    paSegmentTag: { fixedLength: 3, value: "A01", tag: "PA", length: 3 },
    address_1: {
      fixedLength: 45,
      value: getValueAddress({
        currentAddress,
        start: 0,
        end: 45,
      }),
      tag: "01",
      length: getValueAddress({
        currentAddress,
        start: 0,
        end: 45,
      }).length,
    },
    address_2: {
      fixedLength: 45,
      value: getValueAddress({
        currentAddress,
        start: 45,
        end: 90,
      }),
      tag: "02",
      length: getValueAddress({
        currentAddress,
        start: 45,
        end: 90,
      }).length,
    },
    address_3: {
      fixedLength: 45,
      value: getValueAddress({
        currentAddress,
        start: 90,
        end: 135,
      }),
      tag: "03",
      length: getValueAddress({
        currentAddress,
        start: 90,
        end: 135,
      }).length,
    },
    country: { fixedLength: 4, value: "TH", tag: "07", length: 2 },
  };

  // console.log("addressSegment", addressSegment);

  if (!addressSegment?.address_2?.value) {
    delete addressSegment?.address_2;
  }
  if (!addressSegment?.address_3?.value) {
    delete addressSegment?.address_3;
  }
  return addressSegment;
};

export const getValueDateOfBirth = ({ data }) => {
  const splitDate = data?.birthdateTh
    ? data.birthdateTh.split("/")
    : "01/01/1990".split("/");
  const year = +splitDate[2] - 543;
  const month = splitDate[1];
  const day = splitDate[0];
  const dateOfBirth = `${year}${month}${day}`;
  return dateOfBirth;
};

export const checkRecalNotMatch = ({ data, currentDate }) => {
  const amountPastDue = getAmountPastDue({ data, currentDate });
  const oriPastDueOriginal = getValueOriginalPastDue({ data, currentDate });
  let checkPayment = false;
  let buroMonth = getCurrentLocalDateTime(new Date(currentDate)).month;
  for (let index = 0; index < data.evidence.length; index++) {
    const ev = data.evidence[index];
    const evMonth = getCurrentLocalDateTime(new Date(ev.paid_date)).month;
    if (buroMonth === evMonth) {
      checkPayment = true;
      break;
    }
  }

  return oriPastDueOriginal === 0 && amountPastDue !== 0 && checkPayment;
};

export const getValueAddress = ({
  currentAddress,
  start = 0,
  end,
  addressComma = false,
}) => {
  let newAddress = currentAddress?.slice(start, end);

  // if (!addressComma) {
  //   newAddress = newAddress
  //     // .replaceAll("/", " ")
  //     .replaceAll(",", "")
  //     .replaceAll(" ", "")
  //     .replaceAll("?", "");
  // }

  return newAddress || "";
};

export const getValueNumberOfDate = ({ data, currentDate }) => {
  const diffOverDueDays = differenceInDays(
    new Date(currentDate),
    data.overdue_date ? new Date(data.overdue_date) : new Date()
  );

  let numberOfDate = "000";
  if (diffOverDueDays >= 31 && diffOverDueDays <= 60) {
    numberOfDate = "001";
  } else if (diffOverDueDays >= 61 && diffOverDueDays <= 90) {
    numberOfDate = "002";
  } else if (diffOverDueDays >= 91 && diffOverDueDays <= 120) {
    numberOfDate = "003";
  } else if (diffOverDueDays >= 121 && diffOverDueDays <= 150) {
    numberOfDate = "004";
  } else if (diffOverDueDays >= 151 && diffOverDueDays <= 180) {
    numberOfDate = "005";
  } else if (diffOverDueDays >= 181 && diffOverDueDays <= 210) {
    numberOfDate = "006";
  } else if (diffOverDueDays >= 211 && diffOverDueDays <= 240) {
    numberOfDate = "007";
  } else if (diffOverDueDays >= 241 && diffOverDueDays <= 270) {
    numberOfDate = "008";
  } else if (diffOverDueDays >= 271 && diffOverDueDays <= 300) {
    numberOfDate = "009";
  } else if (diffOverDueDays > 300) {
    numberOfDate = "  F";
  }

  if (
    // data?.refinance_amount > 0 ||
    getValueAccountStatus({ data, currentDate }) === 11
    // checkRecalNotMatch({ data, currentDate })
  ) {
    numberOfDate = "000";
  }

  return numberOfDate;
};

export const getValueDefaultDate = ({
  data,
  currentDate,
  formatDate = false,
}) => {
  let new_overdue_date = new Date(data.overdue_date);
  new_overdue_date.setDate(new_overdue_date.getDate() + 1);

  // console.log("data", data);

  // console.log("pastDue", getValuePastDue({ data, currentDate }));

  // if (checkRecalNotMatch({ data, currentDate })) {
  //   return default_date;
  // }

  if (
    getCurrentLocalDateTime(new Date(new_overdue_date)).fullDate >=
    getCurrentLocalDateTime(new Date(currentDate)).fullDate
  ) {
    new_overdue_date = new Date(currentDate);
  }

  if (
    data.loan_status === "DONE" ||
    getValuePastDue({ data, currentDate }) <= 0
  ) {
    if (formatDate) {
      return "1900-01-01";
    }
    return default_date;
  }

  if (formatDate) {
    return format(new_overdue_date, "yyyy-MM-dd");
  }
  return format(new_overdue_date, "yyyyMMdd");
};

export const getValueDateOfLastDebt = ({ data }) => {
  return default_date;
  // return data.refinance_date
  //   ? `${format(new Date(data.refinance_date), "yyyyMMdd")}`
  //   : default_date;
};

export const getValuePaidDateLatest = ({ data, formatDate = false }) => {
  const paid_date_latest = data?.paid_date_latest
    ? format(new Date(data.paid_date_latest), "yyyyMMdd")
    : default_date;

  if (formatDate && data?.paid_date_latest) {
    return format(new Date(data.paid_date_latest), "yyyy-MM-dd");
  }
  return paid_date_latest;
};

export const getValueDateAccountClosed = ({ data, formatDate = false }) => {
  if (data.loan_status === "DONE") {
    return getValuePaidDateLatest({ data, formatDate });
  }

  if (formatDate) {
    return "1900-01-01";
  }
  return default_date;
};

export const legacyValue = ["400122719"];

export const getValueAmountOwed = ({ data, currentDate = new Date() }) => {
  const { installments = [] } = data;

  let buroFullDate = getCurrentLocalDateTime(new Date(currentDate)).fullDate;
  if (
    buroFullDate >= "2022-03-31" &&
    buroFullDate <= "2022-03-01" &&
    data.loan_kbank_id === "400122719"
  ) {
    return "12782";
  }

  if (buroFullDate === "2022-11-30" && data.loan_kbank_id === "500094689") {
    return "46";
  }

  if (data?.loan_kbank_id === "400121357" && buroFullDate === "2022-12-31") {
    return "0";
  }

  if (data.loan_kbank_id === "400066845" && buroFullDate === "2023-01-31") {
    return "8";
  }

  if (data.loan_kbank_id === "400179818" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "400098838" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "500519397" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "400034312" && buroFullDate === "2023-10-31") {
    return "0";
  }

  if (data.loan_kbank_id === "500181992" && buroFullDate === "2023-10-31") {
    return "49";
  }

  if (data.loan_kbank_id === "400179501" && buroFullDate === "2023-11-30") {
    return "30";
  }

  if (data?.loan_kbank_id === "500692182" && buroFullDate === "2024-05-31") {
    return "1";
  }

  // if (data.capitalRemain <= 0) {
  //   return 0;
  // }

  // console.log("installments", installments);

  if (data.loan_kbank_id === "400066113" && buroFullDate === "2022-11-30") {
    return "11515";
  }

  const amountOwed = installments.reduce((prev, installment) => {
    const checkDate =
      format(new Date(currentDate), "yyyy-MM-dd") >= installment.date;
    if (checkDate) {
      return prev + installment.actualInterest;
    }
    return prev;
  }, 0);

  // if (data.refinance_amount > 0) {
  //   return 0;
  // }

  if (round(data.capitalRemain + amountOwed, 0) < 0) {
    return 0;
  }

  return round(data.capitalRemain + amountOwed, 0);
};

export const getValueOriginalPastDue = ({ data, currentDate }) => {
  const { installments = [] } = data?.original;

  const amountPastDue = installments.reduce((prev, installment) => {
    const today = new Date(currentDate);
    const checkDate = format(today, "yyyy-MM-dd") >= installment.date;
    if (checkDate) {
      return prev + installment.actualPrinciple + installment.actualInterest;
    }
    return prev;
  }, 0);

  return amountPastDue;
};

export const getAmountPastDue = ({ data, currentDate }) => {
  const { installments = [] } = data;

  let buroFullDate = getCurrentLocalDateTime(new Date(currentDate)).fullDate;
  if (
    buroFullDate >= "2022-03-31" &&
    buroFullDate <= "2022-03-01" &&
    data.loan_kbank_id === "400122719"
  ) {
    return "2782";
  }

  if (buroFullDate === "2022-11-30" && data.loan_kbank_id === "500094689") {
    return "46";
  }

  if (data?.loan_kbank_id === "400121357" && buroFullDate === "2022-12-31") {
    return "0";
  }

  if (data.loan_kbank_id === "400066845" && buroFullDate === "2023-01-31") {
    return "8";
  }

  if (data.loan_kbank_id === "400179818" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "400098838" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "500519397" && buroFullDate === "2023-09-30") {
    return "0";
  }

  if (data.loan_kbank_id === "500181992" && buroFullDate === "2023-10-31") {
    return "49";
  }

  if (data.loan_kbank_id === "400179501" && buroFullDate === "2023-11-30") {
    return "30";
  }

  if (data?.loan_kbank_id === "500692182" && buroFullDate === "2024-05-31") {
    return "1";
  }

  const amountPastDue = installments.reduce((prev, installment) => {
    const today = new Date(currentDate);
    const checkDate = format(today, "yyyy-MM-dd") >= installment.date;
    if (checkDate) {
      return prev + installment.actualPrinciple + installment.actualInterest;
    }
    return prev;
  }, 0);

  if (amountPastDue > getValueAmountOwed({ data, currentDate })) {
    return getValueAmountOwed({ data, currentDate });
  }

  if (amountPastDue + getValueAmountOwed({ data, currentDate }) === 0) {
    return installments.reduce((prev, installment) => {
      return prev + installment.actualInterest;
    }, 0);
  }

  return amountPastDue;
};

export const getValuePastDue = ({ data, currentDate = new Date() }) => {
  const amountPastDue = getAmountPastDue({ data, currentDate });
  // const oriPastDueOriginal = getValueOriginalPastDue({ data, currentDate });

  // if (checkRecalNotMatch({ data, currentDate })) {
  //   return 0;
  // }

  // console.log(
  //   "getValueOriginalPastDue",
  //   getValueOriginalPastDue({ data, currentDate })
  // );

  // console.log("amountPastDue", amountPastDue);

  // if(data.loan_kbank_id === "400069709"){
  //   return 162
  // }

  if (data?.loan_kbank_id === "400121357") {
    return "0";
  }

  if (
    // data.refinance_amount > 0 ||
    getValueAccountStatus({ data, currentDate }) === 11
  ) {
    return 0;
  }

  return round(amountPastDue, 0);
};

export const getValueInstallmentAmount = ({
  data,
  currentDate = new Date(),
}) => {
  const { installments = [], caseNumber } = data;

  let buroFullDate = getCurrentLocalDateTime(new Date(currentDate)).fullDate;
  if (
    buroFullDate >= "2022-03-31" &&
    buroFullDate <= "2022-03-01" &&
    data.loan_kbank_id === "400122719"
  ) {
    return "1490";
  }

  let currentInstallment = null;
  for (const installment of installments) {
    const checkDate = buroFullDate >= installment.date;
    if (checkDate) {
      currentInstallment = installment;
    }
  }

  // console.log("currentInstallment", currentInstallment);

  // let filterLastIndex = 0;
  // const filterInstallments = [];
  // installments.forEach((installment, index) => {
  //   if (installment.date <= format(new Date(currentDate), "yyyy-MM-dd")) {
  //     filterInstallments.push(installment);
  //     filterLastIndex = index;
  //   }
  // });

  // const lastFilter =
  //   filterInstallments.length > 0
  //     ? filterInstallments[filterInstallments.length - 1]
  //     : null;

  if (
    caseNumber ||
    // || data.refinance_amount > 0
    data.loan_status === "DONE"
  ) {
    return 0;
  }

  if (currentInstallment === null) {
    return installments[0].planInterest + installments[0].planPrinciple;
  }

  // console.log("currentInstallment", currentInstallment);

  if (currentInstallment.isNewInstallment) {
    let lastInstallments = installments.filter(
      (installment) => !installment.isNewInstallment
    );

    return (
      lastInstallments[lastInstallments.length - 1].planInterest +
      lastInstallments[lastInstallments.length - 1].planPrinciple
    );
  }

  return currentInstallment.planInterest + currentInstallment.planPrinciple;

  // console.log("filterInstallments", filterInstallments);
  // console.log("lastFilter", lastFilter);

  //
  // if (
  //   lastFilter?.isNewInstallment ||
  //   lastFilter?.planPrinciple + lastFilter?.planInterest >
  //     getValueAmountOwed({ data, currentDate })
  // ) {
  //   return getValueAmountOwed({ data, currentDate });
  // }

  // console.log("lastFilter", lastFilter);

  // if (lastFilter === null) {
  //   return getValueAmountOwed({ data, currentDate });
  // }

  // if (lastFilter.actualInterest > 0) {
  //   return lastFilter.planInterest + lastFilter.planPrinciple;
  // }

  // if (lastFilter.disabledPeriod) {
  //   let nextInstallmentIndex = filterLastIndex + 1;
  //   if (nextInstallmentIndex > installments.length - 1) {
  //     nextInstallmentIndex = filterLastIndex;
  //   }
  //   return installments[nextInstallmentIndex].planPrinciple;
  // }

  // return lastFilter.planPrinciple;

  // if (data.payPerMonth > getValueAmountOwed({ data, currentDate })) {
  //   return getValueAmountOwed({ data, currentDate });
  // }

  // console.log("lastFilter", lastFilter);
  // console.log("data", data);

  // if (
  //   lastFilter?.isNewInstallment ||
  //   lastFilter?.planPrinciple + lastFilter?.planInterest >
  //     getValueAmountOwed({ data, currentDate })
  // ) {
  //   // console.log("1");
  //   return getValueAmountOwed({ data, currentDate });
  // }

  // // console.log("lastFilter", lastFilter);

  // if (lastFilter === null) {
  //   // console.log("2");
  //   return getValueAmountOwed({ data, currentDate });
  // }

  // if (lastFilter.actualInterest > 0) {
  //   // console.log("3");
  //   return lastFilter.planInterest + lastFilter.planPrinciple;
  // }

  // if (lastFilter.disabledPeriod) {
  //   let nextInstallmentIndex = filterLastIndex + 1;
  //   if (nextInstallmentIndex > installments.length - 1) {
  //     nextInstallmentIndex = filterLastIndex;
  //   }
  //   // console.log("4", nextInstallmentIndex);
  //   return installments[nextInstallmentIndex].planPrinciple;
  // }

  // return data.payPerMonth;
};

export const LEGACY_REF_DONE = ["400121640", "500023095", "400121640"];

export const checkLegacyThreeMonth = ({ data, currentDate }) => {
  const { original, loan_status: recalLoanStatus } = data;
  const { evidence, loan_status } = original;

  // console.log("data", loan_status);
  // console.log("recalLoanStatus", recalLoanStatus);

  let checkPaidDate = false;
  for (let index = 0; index < evidence.length; index++) {
    const ev = evidence[index];
    if (
      ev.paid_date <= "2022-03-01T23:59:59+07:00" &&
      recalLoanStatus === "DONE"
      // loan_status === "DONE"
    ) {
      checkPaidDate = true;
      break;
    }
  }
  return checkPaidDate;
};

export const getValueAccountStatus = ({ data, currentDate }) => {
  const diffOverDueDays = differenceInDays(
    new Date(currentDate),
    data.overdue_date ? new Date(data.overdue_date) : new Date()
  );

  if (data?.loan_kbank_id === "400121357") {
    return 11;
  }

  // console.log(
  //   "checkLegacyThreeMonth",
  //   checkLegacyThreeMonth({ data, currentDate })
  // );

  if (
    data.loan_status === "DONE"
    // ||
    // data.refinance_amount > 0
    // checkLegacyThreeMonth({ data, currentDate })
    // LEGACY_REF_DONE.includes(data?.loan_kbank_id)
  ) {
    return 11;
  } else if (data?.caseNumber) {
    return 30;
  } else if (diffOverDueDays > 90) {
    // return 20;
    let status = 20;
    if (
      data?.overdue_date < "2024-01-01" ||
      legacyStatus21.includes(data?.loan_kbank_id)
    ) {
      status = 21;
    }

    return status;
    // return 21;
  }

  return 10;
};

export const getValueAccountType = ({ data }) => {
  if (data.type === "ธุรกิจ") {
    return "37";
  }
  return "05";
};

export const getValueLoanObject = ({ data }) => {
  if (data.type !== "ธุรกิจ") {
    return "55555";
  }

  return null;
};

export const getValueInstallmentNumberOfPayment = ({ data }) => {
  if (data.caseNumber) {
    return `0`;
  }

  if (data.period > 10) {
    return `00${data.period}`;
  }
  return `000${data.period}`;
};

export const getAccountSegment = ({ data, currentDate }) => {
  const accountSegment = {
    tlSegmentTag: { fixedLength: 4, value: "T001", tag: "TL", length: 4 },
    memberCode: {
      fixedLength: 10,
      value: "CC21070000",
      tag: "01",
      length: "CC21070000".length,
    },
    memberName: { fixedLength: 16, value: "MHS", tag: "02", length: 3 },
    accountNumber: {
      fixedLength: 25,
      value: data?.loan_kbank_id || "",
      tag: "03",
      length: data?.loan_bank_id?.length,
    },
    accountType: {
      fixedLength: 2,
      value: getValueAccountType({ data }),
      tag: "04",
      length: String(getValueAccountType({ data })).length,
    },
    ownershipIndicator: {
      fixedLength: 1,
      value: "1",
      tag: "05",
      length: "1",
    },
    currencyCode: { fixedLength: 3, value: "THB", tag: "06", length: 3 },
    dateAccountOpened: {
      fixedLength: 8,
      value: format(new Date(data?.requestTime), "yyyyMMdd"),
      tag: "08",
      length: String(format(new Date(data?.requestTime), "yyyyMMdd")).length,
    },
    dateOfLastPayment: {
      fixedLength: 8,
      value: getValuePaidDateLatest({ data }),
      tag: "09",
      length: getValuePaidDateLatest({ data }).length,
    },
    dateAccountClosed: {
      fixedLength: 8,
      value: getValueDateAccountClosed({ data }),
      tag: "10",
      length: getValueDateAccountClosed({ data }).length,
    },
    loanAmount: {
      fixedLength: 9,
      value: `${Number(data.requestamount)}`,
      tag: "12",
      length: `${Number(data.requestamount)}`.length,
    },
    amountOwed: {
      fixedLength: 9,
      value: `${getValueAmountOwed({ data, currentDate })}`,
      tag: "13",
      length: `${getValueAmountOwed({ data, currentDate })}`.length,
    },
    amountPastDue: {
      fixedLength: 9,
      value: `${getValuePastDue({ data, currentDate })}`,
      tag: "14",
      length: `${getValuePastDue({ data, currentDate })}`.length,
    },
    numberOfDate: {
      fixedLength: 3,
      value: `${getValueNumberOfDate({ data, currentDate })}`,
      tag: "15",
      length: `${getValueNumberOfDate({ data, currentDate })}`.length,
    },
    defaultDate: {
      fixedLength: 8,
      value: getValueDefaultDate({ data, currentDate }),
      tag: "19",
      length: `${getValueDefaultDate({ data, currentDate })}`.length,
    },
    installmentFrequency: {
      fixedLength: 1,
      value: data?.caseNumber ? "0" : "3",
      tag: "20",
      length: 1,
    },
    installmentAmount: {
      fixedLength: 9,
      value: `${Math.ceil(getValueInstallmentAmount({ data, currentDate }))}`,
      tag: "21",
      length: `${getValueInstallmentAmount({ data, currentDate })}`.length,
    },
    installmentNumberOfPayment: {
      fixedLength: 4,
      value: getValueInstallmentNumberOfPayment({ data }),
      tag: "22",
      length: `${getValueInstallmentNumberOfPayment({ data })}`.length,
    },
    accountStatus: {
      fixedLength: 2,
      value: `${getValueAccountStatus({ data, currentDate })}`,
      tag: "23",
      length: `${getValueAccountStatus({ data, currentDate })}`.length,
    },
    loanObjective: {
      fixedLength: 5,
      value: getValueLoanObject({ data }),
      tag: "32",
      length: `${getValueLoanObject({ data })}`.length,
    },
    dateOfLastDebt: {
      fixedLength: 8,
      value: getValueDateOfLastDebt({ data }),
      tag: "36",
      length: `${getValueDateOfLastDebt({ data })}`.length,
    },
    numberOfCoBorrower: {
      fixedLength: 2,
      value: "00",
      tag: "39",
      length: 2,
    },
  };

  if (getValueLoanObject({ data }) === null) {
    delete accountSegment.loanObjective;
  }

  if (
    Number(accountSegment.amountOwed.value) <
    Number(accountSegment.installmentAmount.value)
  ) {
    // console.log("1");
    // console.log("accountSegment", accountSegment);
    // console.log("data", data.loan_kbank_id);
  }

  if (
    accountSegment.accountStatus.value === "11" &&
    accountSegment.numberOfDate.value !== "000"
  ) {
    console.log("2");
    console.log("accountSegment", accountSegment);
    console.log("data", data.loan_kbank_id);
  }

  if (
    Number(accountSegment.amountPastDue.value) >
    Number(accountSegment.amountOwed.value)
  ) {
    console.log("3");
    console.log("accountSegment", accountSegment);
    console.log("data", data.loan_kbank_id);
  }

  if (
    accountSegment.accountStatus.value === "20" &&
    accountSegment.amountPastDue.value === "0"
  ) {
    console.log("4");
    console.log("accountSegment", accountSegment);
    console.log("data", data.loan_kbank_id);
  }

  if (
    accountSegment.numberOfDate.value !== "000" &&
    accountSegment.amountPastDue.value === "0"
  ) {
    console.log("5");
    console.log("accountSegment", accountSegment);
    console.log("data", data.loan_kbank_id);
  }

  return accountSegment;
};

export const getValueSortSegment = (includeSegment) => {
  const keys = Object.keys(includeSegment);

  const tempSegments = keys.map((key) => {
    return {
      tag: includeSegment[key].tag,
      value: includeSegment[key].value,
      key,
      fixedLength: includeSegment[key].fixedLength,
      length: includeSegment[key].length,
    };
  });
  const sortTempSegments = tempSegments.sort((a, b) => {
    return Number(a.tag) > Number(b.tag) ? 1 : -1;
  });
  return sortTempSegments;
};

export const getDetailSegment = ({
  dataExport = [],
  currentDate,
  showLog = false,
  showConsole = false,
  addressComma = false,
  logType = "LIST",
}) => {
  let keep = [];
  let namePn = "";

  // let filterLegacy = dataExport.filter((item) => {
  //   return checkLegacyThreeMonth({ data: item, currentDate });
  // });

  // console.log("filterLegacy", filterLegacy);

  dataExport.forEach((data) => {
    const includeSegment = {
      ...getNamePnSegment({ data }),
      ...getIdSegment({ data }),
      ...getAddressSegment({ data, addressComma }),
      ...getAccountSegment({ data, currentDate }),
    };

    const keepSegment = {
      ...includeSegment,
    };

    keep.push(keepSegment);
    if (showLog) {
      if (logType === "LIST") {
        namePn = getValueSortSegment(includeSegment);
      } else {
        namePn = keepSegment;
      }
      if (showConsole) {
        console.log(getValueSortSegment(includeSegment));
      }
    } else {
      Object.keys(includeSegment).map((key) => {
        if (includeSegment[key]) {
          const item = includeSegment[key];
          if (item.value !== null) {
            var keepStr = "";
            if (item.value?.length > item?.fixedLength) {
              keepStr += item.value.slice(0, item.fixedLength);
            }

            namePn +=
              keepStr + `${item.tag}${pad(item.value.length)}${item.value}`;
          }
        }
      });
      namePn += `ES02**\n`;
    }
  });

  if (logType === "LIST_ALL") {
    return (keep = keep.map((keep) => {
      const findLoan = dataExport.find(
        (data) => data.loan_kbank_id === keep.accountNumber.value
      );

      if (findLoan) {
        return {
          ...keep,
          capitalRemain: findLoan.capitalRemain,
        };
      }

      return {
        ...keep,
      };
    }));
  }

  // console.log("namePn", namePn);
  return namePn;
};
